// Constants used through app 

export const ACTION_EDIT_CONTACTS = 'action-edit-contacts' 
export const ACTION_ADD_CONTACTS = 'action-add-contacts'
export const ACTION_DEFAULT = 'action-default'
export const NEW_CONTACT = 'new-contact'